import { Component, OnInit, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemesService } from '../../services/themes/themes.service';
import { Theme } from '../../services/themes/theme';
import { SessionMgmtService } from '../../services/session-mgmt/session-mgmt.service';

@Component({
    selector: 'app-ltms-dashboard-themes',
    imports: [CommonModule],
    templateUrl: './ltms-dashboard-themes.component.html',
    styleUrls: ['./ltms-dashboard-themes.component.scss']
})

// Add on HTML template
// <app-ltms-dashboard-themes></app-ltms-dashboard-themes>
export class LtmsDashboardThemesComponent implements OnInit {
  selectedTheme = 'DEFAULT';
  userSelectedTheme = null;
  constructor(
    private themeService: ThemesService,
    private renderer2: Renderer2,
    private _sessionMgmtService: SessionMgmtService
  ) {
    // get theme name if user already selected and stored at LocalStorage
    try {
      this.userSelectedTheme =
        this._sessionMgmtService.getData('LW_THEME_SELECTED');
      if (this.userSelectedTheme && this.userSelectedTheme !== null) {
        this.updateTheme(this.userSelectedTheme);
      }
    } catch (error) {
      console.log('Issue while getting data from LS', error);
      this.userSelectedTheme = null;
    }

    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', () => {
        const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)');
        this.updateThemeIfOSThemeChanged(darkThemeMq);
      });
    const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)');
    this.updateThemeIfOSThemeChanged(darkThemeMq);
  }

  // if OS default theme selected update the current theme
  updateThemeIfOSThemeChanged(darkThemeMq: MediaQueryList) {
    if (darkThemeMq.matches) {
      // Theme set to dark.
      if (this.userSelectedTheme && this.userSelectedTheme !== null) {
        this.updateTheme(this.userSelectedTheme);
      } else {
        this.updateTheme('DARK');
      }
    } else {
      // Theme set to light or default and if user is selected, apply selected theme only.
      if (this.userSelectedTheme && this.userSelectedTheme !== null) {
        this.updateTheme(this.userSelectedTheme);
      } else {
        this.updateTheme('DEFAULT');
      }
    }
  }

  ngOnInit(): void {
    console.log('Deaful Theme is :', this.selectedTheme);
  }

  changeThemeSelectedByuser(themeName: string) {
    this.updateTheme(themeName);
    const setThemeValue = {};
    setThemeValue['name'] = themeName.toString();
    this._sessionMgmtService.setData('LW_THEME_SELECTED', themeName.toString());
  }

  // update the selected theme
  updateTheme(themeName: string) {
    this.selectedTheme = themeName;
    const passThemeNameValue = Theme[themeName];
    this.themeService.setTheme(passThemeNameValue, this.renderer2);
  }
}
